import { render } from "./Law.vue?vue&type=template&id=294e569a&scoped=true"
import script from "./Law.vue?vue&type=script&lang=js"
export * from "./Law.vue?vue&type=script&lang=js"

import "./Law.vue?vue&type=style&index=0&id=294e569a&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294e569a"]])

export default __exports__